export const INITIAL_STATE = {
    feature_flags: {},
    i_am_interested: {},
    call_requested: {},
    chat_cta: {},
    call: {},
    offer: {},
    store_test_drive: {},
    store_visit: {},
    home_test_drive: {},
    ivr_number: {},
    transaction_inbox: {},
    my_zone: {}
};

const actionHandlers = {
    SAVE_FEATURE_FLAG_DATA: (state, action) => ({
        ...state,
        feature_flags: action.data.features,
        i_am_interested: action.data.i_am_interested,
        call_requested: action.data.call_requested,
        chat_cta: action.data.chat_cta,
        call: action.data.call,
        offer: action.data.offer,
        store_test_drive: action.data.store_test_drive,
        store_visit: action.data.store_visit,
        home_test_drive: action.data.home_test_drive,
        ivr_number: action.data.ivr_number,
        transaction_inbox: action.data.transaction_inbox,
        my_zone: action.data.my_zone
    })
};

export default (state = INITIAL_STATE, action) => {
    const handler = actionHandlers[action.type];

    return handler ? handler(state, action) : state;
};
